import PackCardQuietStack from './PackCardQuietStack.jsx';
import OwnRecipesSection from './OwnRecipesSection.jsx';
import OnboardingRecipesAdd from './OnboardingRecipesAdd.jsx';
import './RecipePacks.css';

/**
 * AddViewMature — Add tab content.
 * Recipes you already have, then curated packs.
 */
export default function AddViewMature({
  packs,
  addedPackIds,
  onOpenPack,
  onAddPack,
  urlImportValue,
  onUrlImportChange,
  onUrlImport,
  urlImportLoading,
  urlImportError,
  pasteImportValue,
  onPasteImportChange,
  onPasteImport,
  pasteImportLoading,
  pasteImportError,
  onPhotoImport,
  onConnectedAccount,
  headingLevel = 2,
  onboarding = false,
}) {
  const imports = (
    <OwnRecipesSection
      variant="desktop"
      headingLevel={onboarding ? 2 : headingLevel}
      onboarding={onboarding}
        urlImportValue={urlImportValue}
        onUrlImportChange={onUrlImportChange}
        onUrlImport={onUrlImport}
        urlImportLoading={urlImportLoading}
        urlImportError={urlImportError}
        pasteImportValue={pasteImportValue}
        onPasteImportChange={onPasteImportChange}
        onPasteImport={onPasteImport}
        pasteImportLoading={pasteImportLoading}
        pasteImportError={pasteImportError}
        onPhotoImport={onPhotoImport}
        onConnectedAccount={onConnectedAccount}
    />
  );

  if (onboarding) {
    return (
      <div className="rp-add-view-mature rp-add-view-mature--onboarding">
        <OnboardingRecipesAdd
          packs={packs}
          addedPackIds={addedPackIds}
          onOpenPack={onOpenPack}
          onAddPack={onAddPack}
        />
        {imports}
      </div>
    );
  }

  return (
    <div className="rp-add-view-mature">
      {imports}

      <div className="rp-add-packs">
        <div className="rp-add-section-header">
          <h2 className="rp-section-title">Try some of our favorites.</h2>
          <p className="rp-add-section-subhead">Each one is a group of curated recipes.</p>
        </div>
        <div className="rp-pack-grid-large">
          {packs.map(p => (
            <PackCardQuietStack
              key={p.id}
              pack={p}
              added={addedPackIds.has(p.id)}
              onOpen={() => onOpenPack(p.id)}
              onAdd={onAddPack}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
